// Constants
import { UPDATE_SELECTED_FORM } from "constants/types";

// Helpers
import { apiRequest } from "helpers/apiClient";

export const updateAttachmentWithoutUpload = (file, selectedForm) => (dispatch) => {
    if (!file) {
        return false;
    }
    const vedlegg = {
        filnavn: file.name,
        storrelse: file.size,
        vedleggstype: null,
        mimeType: file.type
    };
    const updatedForm = {
        ...selectedForm,
        vedlegg
    };
    return dispatch({ type: UPDATE_SELECTED_FORM, payload: updatedForm });
};

export const removeAttachmentFromSelectedForm = (selectedForm) => (dispatch) => {
    const updatedForm = {
        ...selectedForm,
        vedlegg: null
    };
    return dispatch({ type: UPDATE_SELECTED_FORM, payload: updatedForm });
};

export const uploadAttachment = (file, selectedForm, accessToken) => (dispatch) => {
    const formData = new FormData();
    formData.append("attachment", file);

    return apiRequest(selectedForm?._links?.vedlegg?.href, {
        method: "POST",
        accessToken,
        body: formData
    }).then((result) => {
        if (result.ok) {
            // Fersk ETag fra opplastingen (opplasting bumper rowversion) - ellers vil neste
            // autolagring sende utdatert If-Match og få 412.
            const updatedForm = {
                ...selectedForm,
                vedlegg: result.data,
                ...(result.etag ? { etag: result.etag } : {})
            };
            dispatch({ type: UPDATE_SELECTED_FORM, payload: updatedForm });
            return {
                status: result.status,
                data: updatedForm
            };
        }
        return {
            status: result.status,
            xCorrelationId: result.xCorrelationId,
            problemDetails: result.problemDetails,
            metadata: {
                fileName: file.name
            }
        };
    });
};
